module.exports = __webpack_public_path__ + "img/taili6.7650c48a.jpg";